<template>
    <div id="user-detail-user-logs">
        <v-card>
            <v-card-title>
                <div>
                    <p class="subtitle-2 mb-0">{{ year }}. {{ month }}. havi munkaórák</p>
                    <p class="display-1 font-weight-thin text--primary mt-0">{{ this.$store.state.monthlyDetail.detailUser.name }}</p>
                </div>
                <div class="flex-grow-1"></div>

                <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
                    <template v-slot:activator="{ on }">
                        <v-text-field v-model="date" label="Hónap kiválasztása" prepend-inner-icon="event" single-line outlined readonly v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="date" v-on:change="requestNewMonth" type="month" :max="today" min="2014-04"  scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false">Mégsem</v-btn>
                    </v-date-picker>
                </v-dialog>
            </v-card-title>
            <UserDetailPrint :year="this.$store.state.monthlyDetail.detailYear" :month="this.$store.state.monthlyDetail.detailMonth" :userId="userId" />
            <UserDetailTable :logs="this.$store.state.monthlyDetail.monthlyDetail.rows" />
        </v-card>
    </div>
</template>

<script>
    import UserDetailTable from "./UserDetailTable";
    import UserDetailPrint from "./UserDetailPrint";
    export default {
        name: "UserLogs",

        data () {
            return {
                userInfo: {},
                year: new Date().getFullYear(),
                month: ("0" + (new Date().getMonth() + 1)).slice(-2),
                modal: false,
                date: new Date().toISOString().substr(0, 7),
                loading: false,
                today: new Date().toISOString().substr(0, 7),
            }
        },

        components: {
            UserDetailTable,
            UserDetailPrint
        },

        props: {
            userId: {
                required: true,
            }
        },

        mounted() {
            this.getUserInfo()
            this.getUserLogs()
        },

        methods: {
            async getUserInfo() {

                this.$store.commit('monthlyDetail/set_detail_year', this.year)
                this.$store.commit('monthlyDetail/set_detail_month', this.month)

                this.$store.dispatch('monthlyDetail/actionDetailUser', [])
                await this.$axios({ url: `/user-data/${this.userId}`, method: 'GET' })
                    .then(resp => {
                        this.$store.dispatch('monthlyDetail/actionDetailUser', resp.data.data)
                    })
            },

            getUserLogs() {
                this.$store.dispatch('monthlyDetail/actionMonthlyDetail', { userId: this.userId, emptyBeforeCreate: true })
            },

            requestNewMonth () {
                this.modal = false
                this.$refs.dialog.save(this.date)

                this.$store.commit('monthlyDetail/set_detail_year', this.date.substring(0, 4))
                this.$store.commit('monthlyDetail/set_detail_month', this.date.substring(this.date.length - 2))

                this.getUserLogs()
            }
        }
    }
</script>

<style lang="scss">
    #user-detail-user-logs {

    }
</style>
